import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTab() {
  const [value, setValue] = React.useState(0);
  const pathname = useLocation().pathname.replace("/SiMS_ReactJS", "");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={pathname}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Customer Rename"
            {...a11yProps(1)}
            sx={{ textTransform: "none" }}
            component={Link}
            to="Customer_Rename"
            value={"/functionaladmin/Customer_Rename"}
          />
          <Tab
            label="Relationship Level"
            {...a11yProps(2)}
            sx={{ textTransform: "none" }}
            component={Link}
            to="Customer_Trust_Level"
            value={"/functionaladmin/Customer_Trust_Level"}
          />
          <Tab
            label="Edit Scenario"
            {...a11yProps(3)}
            sx={{ textTransform: "none" }}
            component={Link}
            to="edit_Scenario"
            value={"/functionaladmin/edit_Scenario"}
          />          
        </Tabs>
      </Box>
    </Box>
  );
}
